/* ATELIER NAV DATA - GENERATED by _gen-nav-v2-data.py --theme, do not
   hand-edit. The v2 nav tree; every link validated against the store's
   real collections; thumbnails = cutout PNGs on Shopify Files
   (upload log: _nav-thumb-files-log.csv). Loaded by
   sections/atelier-header.liquid BEFORE atelier-header.js. */
window.NAV2 = {
  "mega": {
    "bathroom": {
      "t": "Bathroom",
      "ptype": "rail",
      "all": "/collections",
      "cats": [
        {
          "k": "toilets",
          "t": "Toilets",
          "hub": "/pages/toilet-suites",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-toilet-suites.jpg",
          "groups": [
            {
              "h": "By type",
              "links": [
                {
                  "l": "Back-to-Wall Suites",
                  "h": "/collections/back-to-wall-toilet-suites",
                  "n": 38,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-toilet-suites.png?v=1782979632",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "BP-T3_1.webp"
                },
                {
                  "l": "In-Wall Toilet Packages",
                  "h": "/collections/in-wall-toilet-packages",
                  "n": 21,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg?v=1755815225",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wall Faced Pans",
                  "h": "/collections/wall-faced-pans",
                  "n": 14,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-faced-pans.png?v=1782979730",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
                },
                {
                  "l": "Wall Hung Pans",
                  "h": "/collections/wall-hung-pans",
                  "n": 6,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-pans.png?v=1782979731",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Close Coupled Suites",
                  "h": "/collections/close-coupled-toilet-suites",
                  "n": 5,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-close-coupled-toilet-suites.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Smart Toilets",
                  "h": "/collections/smart-toilets",
                  "n": 8,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/KS100_6.jpg?v=1778150707",
                  "cut": 0,
                  "bg": "photo"
                }
              ]
            },
            {
              "h": "In-wall & parts",
              "links": [
                {
                  "l": "Concealed Cisterns",
                  "h": "/collections/in-wall-concealed-cisterns",
                  "n": 8,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-concealed-cisterns.png?v=1782979672",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "In Wall Cistern Buttons",
                  "h": "/collections/in-wall-cistern-buttons",
                  "n": 55,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/DAS_294538_20170926_141550.jpg?v=1755730482",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Back to Wall Toilet Buttons",
                  "h": "/collections/back-to-wall-toilet-buttons",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-cistern-buttons.png?v=1782979661",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bidet Sprays",
                  "h": "/collections/bidet-sprays",
                  "n": 21,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ZAR-BS-DC-CH_01_c8d0941b-9b91-44d5-826c-c4f4df58ae81.jpg?v=1755815418",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Spare Parts",
                  "h": "/collections/toilet-spare-parts",
                  "n": 43,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-spare-parts.png?v=1782979721",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bidet Seats",
                  "h": "/collections/bidet-seats",
                  "n": 5,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Kare-659G-4-Website.jpg?v=1782699201",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/toilet-suites",
          "n": 97,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "baths",
          "t": "Baths",
          "hub": "/pages/bathtubs",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathtubs.jpg",
          "groups": [
            {
              "h": "Shop by Type",
              "links": [
                {
                  "l": "Freestanding Baths",
                  "h": "/collections/freestanding-baths",
                  "n": 143,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-baths.png?v=1782979661",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
                },
                {
                  "l": "Back to Wall Baths",
                  "h": "/collections/back-to-wall-baths",
                  "n": 34,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-baths.png?v=1782979632",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Corner Baths",
                  "h": "/collections/corner-baths",
                  "n": 44,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-corner-baths.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "vienna-lh-1.jpg"
                },
                {
                  "l": "Multi-fit Baths",
                  "h": "/collections/multi-fit-baths",
                  "n": 13,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-multi-fit-baths.png?v=1782979682",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Stone Baths",
                  "h": "/collections/stone-baths",
                  "n": 46,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-baths.png?v=1782979711",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath & Shower Tapware Sets",
                  "h": "/collections/bath-shower-tapware-sets",
                  "n": 32,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Shop by Material",
              "compact": true,
              "links": [
                {
                  "l": "Acrylic",
                  "h": "/collections/bathtubs?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F245019639957",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/FR11775GW-OF.jpg?v=1755753504",
                  "cut": 0
                },
                {
                  "l": "Cast Stone",
                  "h": "/collections/bathtubs?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478083221",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ST17.jpg?v=1755730224",
                  "cut": 0
                }
              ],
              "visual": "material"
            },
            {
              "h": "Shop by Size",
              "compact": true,
              "links": [
                {
                  "l": "1200mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019902101",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "1300mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019934869",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "1400mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019967637",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "1500mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020000405",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "1600mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020033173",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "1700mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020098709",
                  "visual": "size",
                  "shape": "bath"
                },
                {
                  "l": "Over 1700mm",
                  "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020164245",
                  "visual": "size",
                  "shape": "bath"
                }
              ],
              "visual": "size"
            },
            {
              "h": "Finish the look",
              "links": [
                {
                  "l": "Bath Wastes",
                  "h": "/collections/bath-wastes",
                  "n": 53,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath Spouts",
                  "h": "/collections/bath-spouts",
                  "n": 180,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ms05-pvdbn-brushed-nickel-wall-spout-meir-1_1024x1024_db6ae806-9d2b-41d3-819d-556fe651d53b.jpg?v=1755583521",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Freestanding Bath Mixers",
                  "h": "/collections/freestanding-bath-mixers",
                  "n": 119,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/221112-LF.jpg?v=1756341436",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Freestanding Bath Spouts",
                  "h": "/collections/freestanding-bath-spouts",
                  "n": 43,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/20200224114459_970698-scaled.jpg?v=1792190279",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/bathtubs",
          "n": 179,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "tapware",
          "t": "Tapware",
          "hub": "/pages/bathroom-tapware",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
          "groups": [
            {
              "h": "Bathroom",
              "links": [
                {
                  "l": "Basin Mixers",
                  "h": "/collections/basin-mixers",
                  "n": 282,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234103-LF.jpg?v=1756341172",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Tall Basin Mixers",
                  "h": "/collections/tall-basin-mixers",
                  "n": 136,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_1_234107GM.jpg?v=1792129954",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wall Basin Mixers",
                  "h": "/collections/wall-basin-mixers",
                  "n": 171,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234104BN-LF.jpg?v=1756341259",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "3 Piece Taps",
                  "h": "/collections/3-piece-basin-sets",
                  "n": 71,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Harrington-3-Hole-Basin-Set_01.jpg?v=1756344021",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower / Wall Mixers",
                  "h": "/collections/shower-wall-mixers",
                  "n": 244,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234101B-2-LF.jpg?v=1756341354",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Diverter Mixers",
                  "h": "/collections/shower-mixers-diverter",
                  "n": 170,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234102CO-4.jpg?v=1756341388",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Freestanding Bath Mixers",
                  "h": "/collections/freestanding-bath-mixers",
                  "n": 119,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/221112-LF.jpg?v=1756341436",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wall Taps",
                  "h": "/collections/wall-tap-assemblies",
                  "n": 82,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MW08-C-Round-Jumper-Valve-Wall-Top-Assembly-Taps.jpg?v=1755563310",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath Spouts",
                  "h": "/collections/bath-spouts",
                  "n": 180,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ms05-pvdbn-brushed-nickel-wall-spout-meir-1_1024x1024_db6ae806-9d2b-41d3-819d-556fe651d53b.jpg?v=1755583521",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath & Shower Tapware Sets",
                  "h": "/collections/bath-shower-tapware-sets",
                  "n": 32,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Freestanding Bath Spouts",
                  "h": "/collections/freestanding-bath-spouts",
                  "n": 43,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/20200224114459_970698-scaled.jpg?v=1792190279",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Hob Mixers",
                  "h": "/collections/hob-mixers",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/mw12-c_meir_polished_chrome_deck_mounted_mixer-1.jpg?v=1792190283",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Kitchen & laundry",
              "links": [
                {
                  "l": "Kitchen & Laundry Mixers",
                  "h": "/collections/kitchen-mixers",
                  "n": 421,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105BN-LF.jpg?v=1756341214",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Pull Out Kitchen Mixers",
                  "h": "/collections/pull-out-kitchen-mixers",
                  "n": 209,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234108GM_3.jpg?v=1791449460",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Laundry Mixers",
                  "h": "/collections/laundry-mixers",
                  "n": 129,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105B-LF.jpg?v=1756341210",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Boiling, Chilled & Sparkling",
                  "h": "/collections/boiling-chilled-sparkling-taps",
                  "n": 8,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/X51-Intelligent-Dispenser-Matte-Black.jpg?v=1755815831",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Filter Taps",
                  "h": "/collections/filter-taps",
                  "n": 9,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LF248047CP-Craft-Filter-Faucet-scaled-1.png?v=1755816478",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Pot Fillers",
                  "h": "/collections/pot-fillers",
                  "n": 32,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MK21_PVDGM_1.png?v=1791951344",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Outdoor Kitchen Taps",
                  "h": "/collections/outdoor-kitchen-taps",
                  "n": 11,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Kitchen-Mixer-Stainless-Steel-316.jpg?v=1755819887",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Kitchen Tap Sets",
                  "h": "/collections/kitchen-tap-sets",
                  "n": 28,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/kara-kitchen-set_5e9cfdb6ba047.jpg?v=1792190287",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/bathroom-tapware",
          "n": 1708,
          "finishStrip": [
            [
              "Chrome",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
              "chrome"
            ],
            [
              "Matte Black",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
              "matte-black"
            ],
            [
              "Brushed Nickel",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
              "brushed-nickel"
            ],
            [
              "Warm Brushed Nickel",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
              "warm-brushed-nickel"
            ],
            [
              "Gunmetal",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
              "gunmetal"
            ],
            [
              "Brushed Gold",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
              "brushed-gold"
            ],
            [
              "Champagne",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
              "champagne"
            ],
            [
              "Antique Brass",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
              "antique-brass"
            ],
            [
              "Stainless Steel",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
              "stainless-steel"
            ],
            [
              "Matte White",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
              "matte-white"
            ],
            [
              "Brushed Bronze / Copper",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
              "brushed-bronze"
            ],
            [
              "Dusk",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
              "dusk"
            ],
            [
              "Gold",
              "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
              "gold"
            ]
          ],
          "strip": "fin",
          "imageFit": "cover",
          "imagePosition": "72% 55%",
          "range": {
            "t": "Fienza Empire Slim",
            "h": "/collections/fienza-empire",
            "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
            "description": "Coordinate tapware, showers and accessories."
          }
        },
        {
          "k": "showers",
          "t": "Showers",
          "hub": "/pages/showers",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-showers.jpg",
          "groups": [
            {
              "h": "Complete showers",
              "links": [
                {
                  "l": "2-in-1 Multi Function",
                  "h": "/collections/shower-column-set",
                  "n": 251,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/455110CO.jpg?v=1756343664",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Hand Shower on Rail",
                  "h": "/collections/shower-on-rail",
                  "n": 122,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/444118BN.jpg?v=1756343671",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower on Brackets",
                  "h": "/collections/shower-brackets",
                  "n": 148,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/433202B.jpg?v=1756343707",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath & Shower Tapware Sets",
                  "h": "/collections/bath-shower-tapware-sets",
                  "n": 32,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Heads, arms & parts",
              "links": [
                {
                  "l": "Shower Heads",
                  "h": "/collections/shower-heads",
                  "n": 137,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Shower-Rose-300mm-Polished-Chrome.jpg?v=1756434259",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower Head and Arm Sets",
                  "h": "/collections/shower-head-and-arm-sets",
                  "n": 135,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_60_411109-C.jpg?v=1792130459",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Ceiling Shower Arms",
                  "h": "/collections/ceiling-shower-arms",
                  "n": 81,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Ceiling-Shower-Arm-300mm-Matte-Black.jpg?v=1756434286",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wall Shower Arms",
                  "h": "/collections/wall-shower-arms",
                  "n": 86,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Wall-Shower-Arm-400mm-Brushed-Nickel.jpg?v=1756434265",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Hand Shower Pieces",
                  "h": "/collections/hand-shower-piece",
                  "n": 84,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/mp01-r-pvdbz_meir_lustre_bronze_round__hand_shower-1_800x_461c6b96-ebb0-4b4a-b455-9d8439610734.webp?v=1756278871",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower Hoses & Brackets",
                  "h": "/collections/shower-hoses",
                  "n": 6,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/433100.jpg?v=1792187175",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Care & accessibility",
              "links": [
                {
                  "l": "Care & Disabled Showers",
                  "h": "/collections/disabled-shower-products",
                  "n": 20,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/lc401_shower_kit.jpg?v=1792141875",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Screens & mixers",
              "links": [
                {
                  "l": "Shower Screens",
                  "h": "/collections/shower-screens",
                  "n": 49,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
                  "cut": 0,
                  "bg": "photo"
                },
                {
                  "l": "Screen Accessories",
                  "h": "/collections/shower-screen-accessories",
                  "n": 29,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower / Wall Mixers",
                  "h": "/collections/shower-wall-mixers",
                  "n": 244,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234101B-2-LF.jpg?v=1756341354",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/showers",
          "n": 548,
          "finishStrip": [
            [
              "Chrome",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
              "chrome"
            ],
            [
              "Matte Black",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
              "matte-black"
            ],
            [
              "Brushed Nickel",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
              "brushed-nickel"
            ],
            [
              "Warm Brushed Nickel",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
              "warm-brushed-nickel"
            ],
            [
              "Gunmetal",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
              "gunmetal"
            ],
            [
              "Brushed Gold",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
              "brushed-gold"
            ],
            [
              "Champagne",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
              "champagne"
            ],
            [
              "Antique Brass",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
              "antique-brass"
            ],
            [
              "Stainless Steel",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
              "stainless-steel"
            ],
            [
              "Matte White",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
              "matte-white"
            ],
            [
              "Brushed Bronze / Copper",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
              "brushed-bronze"
            ],
            [
              "Dusk",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
              "dusk"
            ],
            [
              "Gold",
              "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
              "gold"
            ]
          ],
          "strip": "fin",
          "imageFit": "cover",
          "imagePosition": "50% 45%",
          "range": {
            "t": "Fienza Empire Slim",
            "h": "/collections/fienza-empire",
            "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-showers.jpg",
            "description": "Discover matching shapes and finishes."
          }
        },
        {
          "t": "Shower Screens",
          "all": "/collections/shower-screens",
          "coll": "/collections/shower-screens",
          "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
          "groups": [
            {
              "h": "Screens & fittings",
              "links": [
                {
                  "l": "Shower Screens",
                  "h": "/collections/shower-screens",
                  "n": 49,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
                  "cut": 0,
                  "bg": "photo"
                },
                {
                  "l": "Screen Accessories",
                  "h": "/collections/shower-screen-accessories",
                  "n": 29,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "brandKey": "showers",
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null,
          "k": "screens",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
          "n": 49
        },
        {
          "k": "basins",
          "t": "Basins",
          "hub": "/pages/basins",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-basins.jpg",
          "groups": [
            {
              "h": "Shop by Type",
              "links": [
                {
                  "l": "Countertop Basins",
                  "h": "/collections/counter-top-basins",
                  "n": 254,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-counter-top-basins.png?v=1782979640",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "hero_basin_ac-800x445-1.jpg"
                },
                {
                  "l": "Wall Hung Basins",
                  "h": "/collections/wall-hung-basins",
                  "n": 37,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-basins.png?v=1782979730",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Undermount Basins",
                  "h": "/collections/under-basins",
                  "n": 39,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-under-basins.png?v=1782979721",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Semi-inset Basins",
                  "h": "/collections/semi-inset-basins",
                  "n": 39,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-semi-inset-basins.png?v=1782979691",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Freestanding Basins",
                  "h": "/collections/freestanding-basins",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-basins.png?v=1782979651",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Inset Basins",
                  "h": "/collections/inset-basins",
                  "n": 10,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-inset-basins.png?v=1782979672",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Compact Basins",
                  "h": "/collections/compact-basins",
                  "n": 6,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-compact-basins.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Cast Stone Basins",
                  "h": "/collections/cast-stone-basins",
                  "n": 61,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cast-stone-basins.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "ovia-fluted.webp"
                }
              ]
            },
            {
              "h": "Shop by Material",
              "compact": true,
              "links": [
                {
                  "l": "Cast Stone",
                  "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478083221",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/CSB01-W-1.jpg?v=1755730221",
                  "cut": 0
                },
                {
                  "l": "Ceramic",
                  "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478050453",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/PA4935-1-800x800.jpg?v=1755562536",
                  "cut": 0
                },
                {
                  "l": "Natural Stone",
                  "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478148757",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/0035MB-5-scaled.jpg?v=1755820345",
                  "cut": 0
                },
                {
                  "l": "Stainless Steel",
                  "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478247061",
                  "visual": "material",
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Ovia-Stainless-Steel-Basin.png?v=1756181839",
                  "cut": 0
                }
              ],
              "visual": "material"
            },
            {
              "h": "Shop by Size",
              "compact": true,
              "links": [
                {
                  "l": "Under 350mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478312597",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "350-400mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478345365",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "400-450mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478378133",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "450-500mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478410901",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "500-600mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478443669",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "600-700mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478476437",
                  "visual": "size",
                  "shape": "basin"
                },
                {
                  "l": "Over 700mm",
                  "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478509205",
                  "visual": "size",
                  "shape": "basin"
                }
              ],
              "visual": "size"
            },
            {
              "h": "Wastes & traps",
              "links": [
                {
                  "l": "Basin Pop Up Wastes",
                  "h": "/collections/pop-up-wastes",
                  "n": 64,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/WAS72UB_1.jpg?v=1792184577",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Overflow Rings",
                  "h": "/collections/basin-overflow-rings",
                  "n": 3,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/OVERFLOWUB.jpg?v=1792183819",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bottle Traps",
                  "h": "/collections/bottle-traps",
                  "n": 39,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Plumbing Parts",
                  "h": "/collections/basin-plumbing-parts",
                  "n": 8,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/2fb2f9df8660903fa6f3655cdb430d2c4f9e772e.jpg?v=1792190979",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Vanity Tops",
              "links": [
                {
                  "l": "Vanity Tops",
                  "h": "/collections/vanity-tops",
                  "n": 17,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/JOL90.jpg?v=1792184579",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Stone Tops",
                  "h": "/collections/stone-tops",
                  "n": 17,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/CrystalPure_503-SF_Full_92d3c819-2958-4998-829b-418e96ad8f0f.jpg?v=1792184581",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/basins",
          "n": 396,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "vanities",
          "t": "Vanities",
          "hub": "/pages/vanities",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/150RWC_2-1.jpg",
          "groups": [
            {
              "h": "By type",
              "links": [
                {
                  "l": "Wall Hung Vanities",
                  "h": "/collections/wall-hung-vanities",
                  "n": 159,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-vanities.png?v=1782979731",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "HE-90W-TO.webp"
                },
                {
                  "l": "Vanities on Legs",
                  "h": "/collections/vanities-on-legs",
                  "n": 22,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-legs.png?v=1782979731",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Vanities on Kickboard",
                  "h": "/collections/vanities-on-kickboard",
                  "n": 35,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-kickboard.png?v=1782979721",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Small Space Vanities",
                  "h": "/collections/small-spaces-vanities",
                  "n": 36,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-small-spaces-vanities.png?v=1782979711",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Extras",
              "links": [
                {
                  "l": "Stone Tops",
                  "h": "/collections/stone-tops",
                  "n": 17,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/CrystalPure_503-SF_Full_92d3c819-2958-4998-829b-418e96ad8f0f.jpg?v=1792184581",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Vanity Tops",
                  "h": "/collections/vanity-tops-bathroom-vanities",
                  "n": 17,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/JOL90_a21cb632-72bf-4b86-b7f5-3637c43f8b58.jpg?v=1792184580",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Cabinet Handles",
                  "h": "/collections/cabinet-handles",
                  "n": 140,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Vanity Builder",
                  "h": "/collections/vanity-builder",
                  "n": 18,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-builder.png?v=1782979731",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/bathroom-vanities",
          "n": 207,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "mirrors",
          "t": "Mirrors & Cabinets",
          "hub": "/pages/mirrors-shaving-cabinets",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/hero_kaya_led_mirror.jpg",
          "groups": [
            {
              "h": "Mirrors",
              "links": [
                {
                  "l": "Plain LED Mirrors",
                  "h": "/collections/led-mirrors",
                  "n": 30,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/600-ROUND_0ffcd049-5a2b-462e-9c0a-604084310e10.webp?v=1792184582",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Framed LED Mirrors",
                  "h": "/collections/framed-led-mirrors",
                  "n": 57,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/led700frub_a4937ee4-aa92-4502-8c95-2dab8377f680.jpg?v=1792183829",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Smart Mirrors",
                  "h": "/collections/smart-mirrors",
                  "n": 2,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Delta-800-1.jpg?v=1782699133",
                  "cut": 0
                },
                {
                  "l": "Round Mirrors",
                  "h": "/collections/rounds",
                  "n": 13,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-rounds.png?v=1782979691",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Pencil Edge Mirrors",
                  "h": "/collections/pencil-edge-mirrors",
                  "n": 23,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pencil-edge-mirrors.png?v=1782979681",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Framed Coloured Mirrors",
                  "h": "/collections/framed-coloured-mirrors",
                  "n": 52,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-framed-coloured-mirrors.png?v=1782979651",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Cabinets",
              "links": [
                {
                  "l": "Shaving Cabinets",
                  "h": "/collections/shaving-cabinets",
                  "n": 111,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shaving-cabinets.png?v=1782979691",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "PSC1200SX-fienza-lifestyle.webp"
                },
                {
                  "l": "LED Shaving Cabinets",
                  "h": "/collections/led-shaving-cabinets",
                  "n": 43,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-shaving-cabinets.png?v=1782979682",
                  "cut": 1,
                  "bg": "cutout",
                  "pv": "AT-5090A-MW1.webp"
                }
              ]
            }
          ],
          "coll": "/collections/mirror-shaving-cabinets",
          "n": 255,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "accessories",
          "t": "Accessories",
          "hub": "/pages/bathroom-accessories",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathroom-accessories.jpg",
          "groups": [
            {
              "h": "Towel rails & holders",
              "links": [
                {
                  "l": "Single Towel Rails",
                  "h": "/collections/towel-bar-rails",
                  "n": 226,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88901600_fb18778d-78d5-4713-abd3-0e9d2d21e58f.jpg?v=1756343824",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Double Towel Rails",
                  "h": "/collections/double-towel-rails",
                  "n": 202,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88908800BN-1_6b8b3f93-7411-47af-93ec-4a6c3897520c.jpg?v=1756343755",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Hand Towel Holders",
                  "h": "/collections/hand-towel-holders",
                  "n": 89,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88902CO_464f8ab9-bb47-4ea2-a079-5d6a7343035e.jpg?v=1756343826",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Towel Rings",
                  "h": "/collections/towel-rings",
                  "n": 48,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/mecca-towel-ring_5e9cd831931a5-scaled.jpg?v=1755749288",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Towel Racks & Ladders",
                  "h": "/collections/towel-racks-ladders",
                  "n": 23,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/mecca-towel-rack_5e9cb4a1c8104-scaled.jpg?v=1792184021",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Everyday accessories",
              "links": [
                {
                  "l": "Toilet Paper Holders",
                  "h": "/collections/paper-holders",
                  "n": 126,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88903B_826d38cd-f1b2-45cd-98ce-ead24f874158.jpg?v=1756343849",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Robe Hooks",
                  "h": "/collections/robe-hooks",
                  "n": 122,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_84_88904GM.jpg?v=1792130800",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath Shelves",
                  "h": "/collections/bathroom-shelves",
                  "n": 47,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88907BN_47199e1f-2dd0-486c-900d-b8b20a2d7c28.jpg?v=1756343724",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Soap Dish Holders",
                  "h": "/collections/soap-dish-holders",
                  "n": 37,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88906_840dc129-fc94-47bd-8ca9-5cc074d865e0.jpg?v=1756343709",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Soap Dispensers",
                  "h": "/collections/soap-dispenser",
                  "n": 15,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MP09-Round-Matte-Black-Soap-Dispenser_1024x1024_7510d66b-90e7-4121-bd72-8ebc7170218b.jpg?v=1755583472",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Toilet Brush Holders",
                  "h": "/collections/toilet-brush-holder",
                  "n": 22,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/889010B_ebc45f4b-3dc9-4288-a40c-abdb6c44b196.jpg?v=1756343711",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bathroom Storage Cabinets",
                  "h": "/collections/bathroom-storage-cabinets",
                  "n": 2,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/IN3030_product.png?v=1792190293",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Warm & practical",
              "links": [
                {
                  "l": "Heated Towel Rails",
                  "h": "/collections/heated-rails",
                  "n": 131,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Heated Towel Rail Accessories",
                  "h": "/collections/heated-towel-rail-accessories",
                  "n": 6,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Jeeves_Elements_JE60_JE120_JE135_JE150_JE220.jpg?v=1792190290",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/bathroom-accessories",
          "n": 925,
          "finishStrip": [
            [
              "Chrome",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
              "chrome"
            ],
            [
              "Matte Black",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
              "matte-black"
            ],
            [
              "Brushed Nickel",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
              "brushed-nickel"
            ],
            [
              "Warm Brushed Nickel",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
              "warm-brushed-nickel"
            ],
            [
              "Gunmetal",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
              "gunmetal"
            ],
            [
              "Brushed Gold",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
              "brushed-gold"
            ],
            [
              "Champagne",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
              "champagne"
            ],
            [
              "Antique Brass",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
              "antique-brass"
            ],
            [
              "Stainless Steel",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
              "stainless-steel"
            ],
            [
              "Matte White",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
              "matte-white"
            ],
            [
              "Black",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F134303907989",
              "black"
            ],
            [
              "Satin/Matte White",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F213295661205",
              "satin-matte-white"
            ],
            [
              "Brushed Bronze / Copper",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
              "brushed-bronze"
            ],
            [
              "Dusk",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
              "dusk"
            ],
            [
              "Gold",
              "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
              "gold"
            ]
          ],
          "strip": "fin",
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": {
            "t": "Fienza Empire Slim",
            "h": "/collections/fienza-empire",
            "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathroom-accessories.jpg",
            "description": "Find the finishing touches for your bathroom."
          }
        },
        {
          "k": "heating",
          "t": "Heating & Cooling",
          "hub": "/pages/heating-cooling",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HEATED-TOWEL-LADDER-GR-lifestyle-image-1.jpg",
          "groups": [
            {
              "h": "Keep it warm",
              "links": [
                {
                  "l": "Heated Towel Rails",
                  "h": "/collections/heated-rails",
                  "n": 131,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Underfloor Heating",
                  "h": "/collections/underfloor-heating",
                  "n": 62,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-underfloor-heating.png?v=1782979721",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Heating Timers & Thermostats",
                  "h": "/collections/heating-thermostats",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-thermostats.png?v=1782979661",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "All Heating & Cooling",
                  "h": "/collections/heating-and-cooling",
                  "n": 155,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Heated Towel Rail Accessories",
                  "h": "/collections/heated-towel-rail-accessories",
                  "n": 6,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Jeeves_Elements_JE60_JE120_JE135_JE150_JE220.jpg?v=1792190290",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/heating-and-cooling",
          "n": 155,
          "finishStrip": [
            [
              "Chrome",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
              "chrome"
            ],
            [
              "Matte Black",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
              "matte-black"
            ],
            [
              "Brushed Nickel",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
              "brushed-nickel"
            ],
            [
              "Warm Brushed Nickel",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
              "warm-brushed-nickel"
            ],
            [
              "Gunmetal",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
              "gunmetal"
            ],
            [
              "Brushed Gold",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
              "brushed-gold"
            ],
            [
              "Champagne",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
              "champagne"
            ],
            [
              "Antique Brass",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
              "antique-brass"
            ],
            [
              "Matte White",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
              "matte-white"
            ],
            [
              "Brushed Bronze / Copper",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
              "brushed-bronze"
            ],
            [
              "Dusk",
              "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
              "dusk"
            ]
          ],
          "strip": "fin",
          "imageFit": "cover",
          "imagePosition": "65% 50%",
          "range": null
        },
        {
          "k": "wastes",
          "t": "Wastes & Traps",
          "hub": "/pages/shower-wastes",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/floorwaste-lifestyle.jpg",
          "groups": [
            {
              "h": "By type",
              "links": [
                {
                  "l": "Floor Wastes",
                  "h": "/collections/floor-wastes",
                  "n": 41,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wastes.png?v=1782979702",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Tile Insert Floor Wastes",
                  "h": "/collections/tile-insert-floor-wastes",
                  "n": 56,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-floor-wastes.png?v=1782979651",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wedge Wire Channels",
                  "h": "/collections/wedge-wire-channels",
                  "n": 20,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/wedge-wire-grates.jpg?v=1755469687",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Tile Insert Channels",
                  "h": "/collections/tile-insert-channels",
                  "n": 30,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/lauxes-sti21-midnight-product.jpg?v=1792053545",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bath Wastes",
                  "h": "/collections/bath-wastes",
                  "n": 53,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Pop Up Wastes",
                  "h": "/collections/pop-up-wastes",
                  "n": 64,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/WAS72UB_1.jpg?v=1792184577",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Overflow Rings",
                  "h": "/collections/basin-overflow-rings",
                  "n": 3,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/OVERFLOWUB.jpg?v=1792183819",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Bottle Traps",
                  "h": "/collections/bottle-traps",
                  "n": 39,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Plumbing Parts",
                  "h": "/collections/basin-plumbing-parts",
                  "n": 8,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/2fb2f9df8660903fa6f3655cdb430d2c4f9e772e.jpg?v=1792190979",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/shower-wastes",
          "n": 88,
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        },
        {
          "k": "care",
          "t": "Care & Ambulant",
          "hub": "/pages/disabled-care",
          "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-special-disabled.jpg",
          "groups": [
            {
              "h": "Care toilets & support",
              "links": [
                {
                  "l": "Care & Extra-Height Toilets",
                  "h": "/collections/care-toilets",
                  "n": 10,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ZurichBTW2.png?v=1792141836",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Care Toilet Suites",
                  "h": "/collections/disabled-toilet-suites",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Fienza-Disabled-Delta-Care-Back-to-Wall-Suite-Blue-Seat-S-Trap_01.jpg?v=1792141839",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Ambulant Toilets",
                  "h": "/collections/ambulant-toilets",
                  "n": 2,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Vera-MB-020_703b99df-9711-42fc-8348-74d6b2fb7aa5.png?v=1792141841",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Ambulant Grab Rails",
                  "h": "/collections/ambulant-grab-rails",
                  "n": 21,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/FC4141.jpg?v=1792141844",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Grab Rails & Backrests",
                  "h": "/collections/grab-rails-back-rests",
                  "n": 156,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MLR120LH_VPSET.jpg?v=1792141850",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Care Toilet Accessories",
                  "h": "/collections/care-toilet-accessories",
                  "n": 18,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/200990_3.jpg?v=1792141853",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Disabled tapware",
              "links": [
                {
                  "l": "All Disabled Tapware",
                  "h": "/collections/disabled-tapware",
                  "n": 43,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Kaya_228103D.jpg?v=1792141830",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Basin Taps & Mixers",
                  "h": "/collections/disability-basin-mixers",
                  "n": 23,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/213109D.jpg?v=1792141856",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Wall & Shower Mixers",
                  "h": "/collections/disability-shower-wall-mixers",
                  "n": 10,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221909XCH.png?v=1792141859",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Kitchen & Sink Mixers",
                  "h": "/collections/disability-kitchen-mixers",
                  "n": 3,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/213110D.jpg?v=1792141862",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Extended Mixer Handles",
                  "h": "/collections/extended-mixer-handles",
                  "n": 7,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/classic-care-handle-only_5e9cf7d0cb28b-scaled.jpg?v=1792141865",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            },
            {
              "h": "Basins, showers & accessories",
              "links": [
                {
                  "l": "Care Basins",
                  "h": "/collections/disability-basins",
                  "n": 5,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/RB379S_88204e88-c779-4540-ba06-39823ea52c9e.jpg?v=1792141868",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Care Mirrors",
                  "h": "/collections/disabled-mirror",
                  "n": 5,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/PEM-4595_5_d9e15366-4b4c-420f-85b3-40111456d668.jpg?v=1792141872",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Care Showers",
                  "h": "/collections/disabled-shower-products",
                  "n": 20,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/lc401_shower_kit.jpg?v=1792141875",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Shower Seats",
                  "h": "/collections/shower-seats-shower-related",
                  "n": 9,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/202099.jpg?v=1792141878",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Care Bathroom Accessories",
                  "h": "/collections/care-bathroom-accessories",
                  "n": 24,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MCR-TPH-PVDBB.webp?v=1792141880",
                  "cut": 1,
                  "bg": "cutout"
                },
                {
                  "l": "Accessible Washroom Accessories",
                  "h": "/collections/accessible-washroom-accessories",
                  "n": 52,
                  "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ml-725-ss-paper-towel-dispenser.jpg?v=1792141883",
                  "cut": 1,
                  "bg": "cutout"
                }
              ]
            }
          ],
          "coll": "/collections/disabled-care-products",
          "n": 315,
          "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Disabled_9fafc5ce-5d45-4c5b-b223-5d058e56f216.jpg?v=1792141823",
          "imageFit": "cover",
          "imagePosition": "50% 50%",
          "range": null
        }
      ],
      "brandKey": "bathroom"
    },
    "kitchen": {
      "t": "Kitchen",
      "ptype": "std",
      "all": "/collections/kitchen",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/2020-03-1615.06.51-1_UNDERMOUNT_1443x_036f11ae-f959-4679-ada8-f761f19a42d3.webp",
      "hub": "/pages/kitchen-laundry-sinks",
      "guideT": "Kitchen & laundry Hub",
      "quick": [
        [
          "Instant Ship",
          "/collections/instant-ship"
        ],
        [
          "Shop Packages",
          "/collections/bathroom-packages"
        ],
        [
          "Clearance",
          "/collections/clearance"
        ]
      ],
      "groups": [
        {
          "h": "Sinks",
          "links": [
            {
              "l": "All Kitchen Sinks",
              "h": "/collections/sinks-laundry-tubs",
              "n": 121,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sinks-laundry-tubs.png?v=1782979711",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Single Bowl Sinks",
              "h": "/collections/single-bowls",
              "n": 80,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-single-bowls.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Double Bowl Sinks",
              "h": "/collections/double-bowls",
              "n": 40,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-double-bowls.png?v=1782979651",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Butler Sinks",
              "h": "/collections/butlers-ceramic-sink",
              "n": 24,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-butlers-ceramic-sink.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Granite Sinks",
              "h": "/collections/granite-sinks",
              "n": 55,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-granite-sinks.png?v=1782979661",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Sink Accessories",
              "h": "/collections/sink-accessories",
              "n": 71,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sink-accessories.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Tapware",
          "links": [
            {
              "l": "Kitchen Mixers",
              "h": "/collections/kitchen-mixers",
              "n": 421,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105BN-LF.jpg?v=1756341214",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pull Out Kitchen Mixers",
              "h": "/collections/pull-out-kitchen-mixers",
              "n": 209,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234108GM_3.jpg?v=1791449460",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Boiling, Chilled & Sparkling",
              "h": "/collections/boiling-chilled-sparkling-taps",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/X51-Intelligent-Dispenser-Matte-Black.jpg?v=1755815831",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Filter Taps",
              "h": "/collections/filter-taps",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LF248047CP-Craft-Filter-Faucet-scaled-1.png?v=1755816478",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pot Fillers",
              "h": "/collections/pot-fillers",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MK21_PVDGM_1.png?v=1791951344",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Kitchen Tap Sets",
              "h": "/collections/kitchen-tap-sets",
              "n": 28,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/kara-kitchen-set_5e9cfdb6ba047.jpg?v=1792190287",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Finishing touches",
          "links": [
            {
              "l": "Kitchen Accessories",
              "h": "/collections/kitchen-accessories",
              "n": 46,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-accessories.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "kitchen",
      "finishStrip": [
        [
          "Chrome",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "range": {
        "t": "Meir Lavello",
        "h": "/collections/meir-lavello",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/2020-03-1615.06.51-1_UNDERMOUNT_1443x_036f11ae-f959-4679-ada8-f761f19a42d3.webp",
        "description": "Discover the kitchen sink collection."
      }
    },
    "laundry": {
      "t": "Laundry",
      "ptype": "std",
      "all": "/collections/laundry",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/SinkHero_Butler2-600x333-1.jpg",
      "hub": "/pages/kitchen-laundry-sinks",
      "guideT": "Kitchen & laundry Hub",
      "quick": [
        [
          "Instant Ship",
          "/collections/instant-ship"
        ],
        [
          "Shop Packages",
          "/collections/bathroom-packages"
        ],
        [
          "Clearance",
          "/collections/clearance"
        ]
      ],
      "groups": [
        {
          "h": "The laundry",
          "links": [
            {
              "l": "Laundry & Butler Sinks",
              "h": "/collections/laundry-and-butler-sinks",
              "n": 261,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-and-butler-sinks.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Tubs",
              "h": "/collections/laundry-tubs",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-tubs.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Mixers",
              "h": "/collections/laundry-mixers",
              "n": 129,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105B-LF.jpg?v=1756341210",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Taps",
              "h": "/collections/wall-tap-assemblies",
              "n": 82,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MW08-C-Round-Jumper-Valve-Wall-Top-Assembly-Taps.jpg?v=1755563310",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Finishing touches",
          "links": [
            {
              "l": "Heated Towel Rails",
              "h": "/collections/heated-rails",
              "n": 131,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Robe Hooks",
              "h": "/collections/robe-hooks",
              "n": 122,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_84_88904GM.jpg?v=1792130800",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "laundry",
      "finishStrip": [
        [
          "Chrome",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "range": null
    },
    "tapware": {
      "t": "Tapware",
      "ptype": "std",
      "all": "/collections/bathroom-tapware",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
      "hub": "/pages/bathroom-tapware",
      "guideT": "Tapware Hub",
      "strip": "fin",
      "promo": 1,
      "groups": [
        {
          "h": "Bathroom",
          "links": [
            {
              "l": "Basin Mixers",
              "h": "/collections/basin-mixers",
              "n": 282,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234103-LF.jpg?v=1756341172",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Tall Basin Mixers",
              "h": "/collections/tall-basin-mixers",
              "n": 136,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_1_234107GM.jpg?v=1792129954",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Basin Mixers",
              "h": "/collections/wall-basin-mixers",
              "n": 171,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234104BN-LF.jpg?v=1756341259",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "3 Piece Taps",
              "h": "/collections/3-piece-basin-sets",
              "n": 71,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Harrington-3-Hole-Basin-Set_01.jpg?v=1756344021",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower / Wall Mixers",
              "h": "/collections/shower-wall-mixers",
              "n": 244,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234101B-2-LF.jpg?v=1756341354",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Diverter Mixers",
              "h": "/collections/shower-mixers-diverter",
              "n": 170,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234102CO-4.jpg?v=1756341388",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Mixers",
              "h": "/collections/freestanding-bath-mixers",
              "n": 119,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/221112-LF.jpg?v=1756341436",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Taps",
              "h": "/collections/wall-tap-assemblies",
              "n": 82,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MW08-C-Round-Jumper-Valve-Wall-Top-Assembly-Taps.jpg?v=1755563310",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath Spouts",
              "h": "/collections/bath-spouts",
              "n": 180,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ms05-pvdbn-brushed-nickel-wall-spout-meir-1_1024x1024_db6ae806-9d2b-41d3-819d-556fe651d53b.jpg?v=1755583521",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath & Shower Tapware Sets",
              "h": "/collections/bath-shower-tapware-sets",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Spouts",
              "h": "/collections/freestanding-bath-spouts",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/20200224114459_970698-scaled.jpg?v=1792190279",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hob Mixers",
              "h": "/collections/hob-mixers",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/mw12-c_meir_polished_chrome_deck_mounted_mixer-1.jpg?v=1792190283",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Kitchen & laundry",
          "links": [
            {
              "l": "Kitchen & Laundry Mixers",
              "h": "/collections/kitchen-mixers",
              "n": 421,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105BN-LF.jpg?v=1756341214",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pull Out Kitchen Mixers",
              "h": "/collections/pull-out-kitchen-mixers",
              "n": 209,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234108GM_3.jpg?v=1791449460",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Mixers",
              "h": "/collections/laundry-mixers",
              "n": 129,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105B-LF.jpg?v=1756341210",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Boiling, Chilled & Sparkling",
              "h": "/collections/boiling-chilled-sparkling-taps",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/X51-Intelligent-Dispenser-Matte-Black.jpg?v=1755815831",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Filter Taps",
              "h": "/collections/filter-taps",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LF248047CP-Craft-Filter-Faucet-scaled-1.png?v=1755816478",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pot Fillers",
              "h": "/collections/pot-fillers",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MK21_PVDGM_1.png?v=1791951344",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Kitchen Taps",
              "h": "/collections/outdoor-kitchen-taps",
              "n": 11,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Kitchen-Mixer-Stainless-Steel-316.jpg?v=1755819887",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Kitchen Tap Sets",
              "h": "/collections/kitchen-tap-sets",
              "n": 28,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/kara-kitchen-set_5e9cfdb6ba047.jpg?v=1792190287",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "tapware",
      "finishStrip": [
        [
          "Chrome",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "range": {
        "t": "Fienza Empire Slim",
        "h": "/collections/fienza-empire",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
        "description": "Coordinate tapware, showers and accessories."
      }
    },
    "colours": {
      "t": "Colours",
      "ptype": "colours",
      "all": "/pages/colours",
      "finishes": [
        {
          "l": "Antique Brass",
          "h": "/collections/antique-brass-tapware",
          "sw": "antique-brass"
        },
        {
          "l": "Brushed Nickel",
          "h": "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "sw": "brushed-nickel"
        },
        {
          "l": "Warm Brushed Nickel",
          "h": "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "sw": "warm-brushed-nickel"
        },
        {
          "l": "Brushed Gold",
          "h": "/collections/brushed-gold-tapware",
          "sw": "brushed-gold"
        },
        {
          "l": "Gunmetal",
          "h": "/collections/colour-gunmetal",
          "sw": "gunmetal"
        },
        {
          "l": "Matte White",
          "h": "/collections/colour-matte-white",
          "sw": "matte-white"
        },
        {
          "l": "Matte Black",
          "h": "/collections/colour-matte-black",
          "sw": "matte-black"
        },
        {
          "l": "Champagne",
          "h": "/collections/colour-champagne",
          "sw": "champagne"
        },
        {
          "l": "Chrome",
          "h": "/collections/colour-chrome",
          "sw": "chrome"
        },
        {
          "l": "Brushed Bronze",
          "h": "/collections/colour-brushed-bronze",
          "sw": "brushed-bronze"
        },
        {
          "l": "Brushed Copper",
          "h": "/collections/colour-brushed-copper",
          "sw": "brushed-copper"
        },
        {
          "l": "Black",
          "h": "/collections/colour-black",
          "sw": "black"
        },
        {
          "l": "Grey",
          "h": "/collections/colour-grey",
          "sw": "grey"
        },
        {
          "l": "Stainless Steel",
          "h": "/collections/colour-stainless-steel",
          "sw": "stainless-steel"
        },
        {
          "l": "White",
          "h": "/collections/colour-white",
          "sw": "white"
        }
      ],
      "brandKey": "colours"
    },
    "brands": {
      "t": "Brands",
      "ptype": "brands",
      "all": "/pages/brands",
      "featured": {
        "name": "Ovia",
        "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_ovia_product-150x150.png?v=1741661801",
        "h": "/collections/ovia",
        "n": 332,
        "d": "A complete bathroomware range — tapware, showers, basins, baths, toilet suites and accessories, with dedicated commercial and accessibility (care) lines. Practical, hard-wearing fixtures at fair everyday prices, so you can fit out a whole bathroom from one dependable range."
      },
      "brands": [
        {
          "name": "Fienza",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/FienzaLogo-1.png?v=1741662706",
          "h": "/collections/fienza",
          "n": 1049,
          "d": "Established Australian brand with one of the widest bathroom ranges — vanities (including Australian-made cabinetry), tapware, basins, baths and toilets — backed by strong warranties."
        },
        {
          "name": "Nero",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NeroLogo-1.png?v=1741662670",
          "h": "/collections/nero",
          "n": 1028,
          "d": "Australian-designed solid-brass tapware and mixers for bath, kitchen and laundry across a wide finish range — quality styling at accessible mid-range pricing."
        },
        {
          "name": "Meir",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MeirLogo-1.png?v=1741662639",
          "h": "/collections/meir",
          "n": 652,
          "d": "Australian designer brand known for premium tapware and showers in bold finishes — matte black, aged brass, rose gold — built from DZR brass and backed by a lifetime guarantee."
        },
        {
          "name": "Modern National",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ModernNationalLogo-1.png?v=1741663791",
          "h": "/collections/modern-national",
          "n": 418,
          "d": "Australian-owned brand bringing current design to tapware, showers, baths and accessories in solid brass, at an approachable mid-range price."
        },
        {
          "name": "ADP",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ADPLogo-1_1.png?v=1741664296",
          "h": "/collections/architectural-designer-products-adp",
          "n": 376,
          "d": "Australian family-owned manufacturer of premium, Australian-made bathroom furniture — vanities, mirrored cabinets, basins, mirrors and baths — crafted in its own factory south of Sydney."
        },
        {
          "name": "Greens Tapware",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_green-150x150.png?v=1741659584",
          "h": "/collections/greens-tapwares",
          "n": 284,
          "d": "New Zealand-designed tapware and showers with heritage back to 1935 — design- and engineering-led, meeting Australian and NZ standards."
        },
        {
          "name": "Mercio",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MercioLogo-1.png?v=1741664296",
          "h": "/collections/mercio",
          "n": 208,
          "d": "Australian bathroom supplier with a broad, well-stocked range — vanities, basins (ceramic and stone), toilets, baths, tapware and mirrors — backing renovators and builders with locally held stock."
        },
        {
          "name": "Aquaperla",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/AquaperlaLogo-1.png?v=1741664286",
          "h": "/collections/aquaperla",
          "n": 194,
          "d": "Proudly Australian-owned, offering well-priced, modern tapware and fixtures for bathroom, kitchen and laundry — compliant with Australian plumbing standards."
        },
        {
          "name": "Metlam",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MetlamLogo-1.png?v=1741663836",
          "h": "/collections/metlam",
          "n": 116,
          "d": ""
        },
        {
          "name": "Geberit",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/GeberitLogo-1.png?v=1741663836",
          "h": "/collections/geberit",
          "n": 81,
          "d": "A global leader in concealed sanitary technology — Swiss-designed, German-made in-wall cisterns and flush plates (Sigma, Omega, Alpha) engineered for quiet, water-efficient dual flushing."
        },
        {
          "name": "Linkware",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LinkwareLogo-1.png?v=1741664296",
          "h": "/collections/linkware",
          "n": 80,
          "d": "Australian designer and manufacturer of value-focused tapware and bathroom brassware, accredited to Australian Standards and widely stocked."
        },
        {
          "name": "Madu Living",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MAIN.png?v=1791713975",
          "h": "/collections/madu-living",
          "n": 30,
          "d": ""
        },
        {
          "name": "ART Australia",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_art_australia-150x150.png?v=1741661801",
          "h": "/collections/art-australia",
          "n": 23,
          "d": ""
        },
        {
          "name": "Oliveri",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/OliveriLogo-1.png?v=1741663836",
          "h": "/collections/oliveri",
          "n": 22,
          "d": "South Australian icon making kitchen and laundry sinks in Adelaide since 1947 — the pioneer of the pressed-bowl process — plus taps and water filtration."
        },
        {
          "name": "Zumi",
          "h": "/collections/zumi",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/zumi-logo.webp?v=1783553384",
          "n": 74,
          "d": ""
        },
        {
          "name": "Lukka",
          "h": "/collections/lukka",
          "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/lukka-logo.png?v=1791713748",
          "n": 26,
          "d": ""
        }
      ],
      "brandKey": "brands"
    },
    "doors": {
      "t": "Door Hardware",
      "ptype": "std",
      "all": "/collections/door-hardware",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-door-hardware.jpg",
      "groups": [
        {
          "h": "Handles",
          "links": [
            {
              "l": "Cabinet Handles",
              "h": "/collections/cabinet-handles",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Handles",
              "h": "/collections/door-handles",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH1-PA-PVDBB-2.jpg?v=1791949998",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Sliding Door Hardware",
              "h": "/collections/sliding-door-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH-E1-PVDGM.jpg?v=1791951202",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Hardware & Fittings",
          "links": [
            {
              "l": "Hinges",
              "h": "/collections/hinges",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH-H1-PVDBB-1.jpg?v=1791950063",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Bumper",
              "h": "/collections/door-bumper",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-0670-door-stop.jpg?v=1755740189",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Accessories",
              "h": "/collections/door-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML4160-Coat-Hook1.jpg?v=1755740305",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Locks, Latches & Cylinders",
              "h": "/collections/locks-latches-cylinders",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Cambridge-SB-Lever-e1635219826340.jpg?v=1756277191",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "quick": [
        [
          "Instant Ship",
          "/collections/instant-ship"
        ],
        [
          "Shop Packages",
          "/collections/bathroom-packages"
        ],
        [
          "Clearance",
          "/collections/clearance"
        ]
      ],
      "strip": "fin",
      "brandKey": "doors",
      "range": {
        "t": "Meir Öppen",
        "h": "/collections/meir-oppen",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Collections-OppenCabinetHandles_1402x_218819fb-89bf-4e31-b671-9546e9f3d931.webp",
        "description": "Coordinated handles for your cabinetry."
      }
    },
    "commercial": {
      "t": "Commercial",
      "ptype": "std",
      "all": "/collections/commercial-range",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/abby-mb_1.webp?v=1756427448",
      "groups": [
        {
          "h": "Washroom Essentials",
          "links": [
            {
              "l": "Hand Dryers",
              "h": "/collections/hand-dryers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/abby-mb_1.webp?v=1756427448",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Soap Dispensers",
              "h": "/collections/soap-dispensers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MBSOAPOVIA.jpg?v=1781215904",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Paper Towel Combination Units",
              "h": "/collections/paper-towel-combination-units",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HSD-E6015-Black-1_cdafbea4-95f6-4c3d-b938-182cbb184a4d.png?v=1756278516",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Toilet Roll Dispensers",
              "h": "/collections/toilet-roll-dispensers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HSD-118-Brushed.jpg?v=1752812445",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Baby Change Stations",
              "h": "/collections/baby-change-stations",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML8100H-Open.jpg?v=1755740366",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Care & Accessibility",
          "links": [
            {
              "l": "Grab Rails & Back Rests",
              "h": "/collections/grab-rails-back-rests",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MLR120LH_VPSET.jpg?v=1792141850",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower Seats & Shower Related",
              "h": "/collections/shower-seats-shower-related",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/202099.jpg?v=1792141878",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Specialised Tapware",
              "h": "/collections/specialised-tapware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NR402BZ-1-1.png?v=1756434093",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Mirrors",
              "h": "/collections/mirrors",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/PEM-6095_5.jpg?v=1756434196",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Security & Anti-Ligature Products",
              "h": "/collections/security-anti-ligature-products",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-773ml-1-1.jpg?v=1755740332",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Disabled Tapware",
              "h": "/collections/disabled-tapware",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Kaya_228103D.jpg?v=1792141830",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Ambulant Bathroom Products",
              "h": "/collections/ambulant-bathroom-products",
              "n": 25,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Fienza-ALIX-Rimless-Ambulant-Back-to-Wall-Toilet-Suite-Slim-Seat-Short-Projection.jpg?v=1792141827",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Accessible Washroom Accessories",
              "h": "/collections/accessible-washroom-accessories",
              "n": 52,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ml-725-ss-paper-towel-dispenser.jpg?v=1792141883",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Hardware & Accessories",
          "links": [
            {
              "l": "Commercial Door Hardware",
              "h": "/collections/commercial-door-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ANMB_300.jpg?v=1755740124",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Antimicrobial Hardware",
              "h": "/collections/antimicrobial-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ANMB_XCELSLIDELOCK.jpg?v=1755740173",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bathroom Series",
              "h": "/collections/bathroom-series",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML6000PSS-Lawson-Single-Toilet-Roll-Holder1.jpg?v=1755740362",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hooks",
              "h": "/collections/hooks",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-4155-equipment-hook.jpg?v=1755740296",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shelves",
              "h": "/collections/shelves",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML9501.jpg?v=1755740082",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Washroom Accessories",
              "h": "/collections/washroom-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-710-r-waste-receptacle.jpg?v=1755740221",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "quick": [
        [
          "Instant Ship",
          "/collections/instant-ship"
        ],
        [
          "Shop Packages",
          "/collections/bathroom-packages"
        ],
        [
          "Clearance",
          "/collections/clearance"
        ]
      ],
      "strip": "quick",
      "brandKey": "commercial",
      "range": null
    },
    "outdoor": {
      "t": "Outdoor",
      "ptype": "std",
      "all": "/collections/outdoor",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LifestyleRange_OutdoorCombinationShowerRail_MZ1004N-R-SS316_1_1600x_f70f2f9b-6615-4257-8485-056104f1d66e.webp",
      "groups": [
        {
          "h": "Showers & Tapware",
          "links": [
            {
              "l": "Outdoor Shower",
              "h": "/collections/outdoor-shower",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NR162205C01BZ-1-450x450-1.png?v=1756340598",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Tapware",
              "h": "/collections/outdoor-tapware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Linkware-Elle-316-Wall-Mixer-Matte-Black.jpg?v=1756278254",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Accessories",
              "h": "/collections/outdoor-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Robe-Hook-Stainless-Steel.jpg?v=1755819892",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Outdoor Kitchens",
          "links": [
            {
              "l": "Outdoor Kitchen Sinks",
              "h": "/collections/outdoor-kitchen-sinks",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Single-Bowl-440x440-Outdoor-Sink-Stainless-Steel-316.jpg?v=1755819889",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Kitchen Taps",
              "h": "/collections/outdoor-kitchen-taps",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Kitchen-Mixer-Stainless-Steel-316.jpg?v=1755819887",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Drainage",
          "links": [
            {
              "l": "Pool & Shower Grates",
              "h": "/collections/pool-shower-grates",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/tile-inserts.jpg?v=1755469681",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Pool & Shower Wastes",
              "h": "/collections/outdoor-pool-shower-wastes",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/lauxes-sti21-midnight-product.jpg?v=1792053545",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "quick": [
        [
          "Instant Ship",
          "/collections/instant-ship"
        ],
        [
          "Shop Packages",
          "/collections/bathroom-packages"
        ],
        [
          "Clearance",
          "/collections/clearance"
        ]
      ],
      "strip": "fin",
      "brandKey": "outdoor",
      "finishStrip": [
        [
          "Chrome",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Stainless Steel",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ]
      ],
      "range": null
    }
  },
  "finishes": [
    [
      "Antique Brass",
      "/collections/antique-brass-tapware",
      "antique-brass"
    ],
    [
      "Brushed Nickel",
      "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
      "brushed-nickel"
    ],
    [
      "Warm Brushed Nickel",
      "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
      "warm-brushed-nickel"
    ],
    [
      "Brushed Gold",
      "/collections/brushed-gold-tapware",
      "brushed-gold"
    ],
    [
      "Gunmetal",
      "/collections/colour-gunmetal",
      "gunmetal"
    ],
    [
      "Matte White",
      "/collections/colour-matte-white",
      "matte-white"
    ],
    [
      "Matte Black",
      "/collections/colour-matte-black",
      "matte-black"
    ],
    [
      "Champagne",
      "/collections/colour-champagne",
      "champagne"
    ],
    [
      "Chrome",
      "/collections/colour-chrome",
      "chrome"
    ],
    [
      "Brushed Bronze",
      "/collections/colour-brushed-bronze",
      "brushed-bronze"
    ],
    [
      "Brushed Copper",
      "/collections/colour-brushed-copper",
      "brushed-copper"
    ],
    [
      "Black",
      "/collections/colour-black",
      "black"
    ],
    [
      "Grey",
      "/collections/colour-grey",
      "grey"
    ],
    [
      "Stainless Steel",
      "/collections/colour-stainless-steel",
      "stainless-steel"
    ],
    [
      "White",
      "/collections/colour-white",
      "white"
    ]
  ],
  "finishStrip": [
    [
      "Matte White",
      "/collections/colour-matte-white",
      "matte-white"
    ],
    [
      "Chrome",
      "/collections/colour-chrome",
      "chrome"
    ],
    [
      "Stainless Steel",
      "/collections/colour-stainless-steel",
      "stainless-steel"
    ],
    [
      "Brushed Nickel",
      "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
      "brushed-nickel"
    ],
    [
      "Warm Brushed Nickel",
      "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
      "warm-brushed-nickel"
    ],
    [
      "Champagne",
      "/collections/colour-champagne",
      "champagne"
    ],
    [
      "Brushed Gold",
      "/collections/brushed-gold-tapware",
      "brushed-gold"
    ],
    [
      "Brushed Bronze",
      "/collections/colour-brushed-bronze",
      "brushed-bronze"
    ],
    [
      "Brushed Copper",
      "/collections/colour-brushed-copper",
      "brushed-copper"
    ],
    [
      "Antique Brass",
      "/collections/antique-brass-tapware",
      "antique-brass"
    ],
    [
      "Gunmetal",
      "/collections/colour-gunmetal",
      "gunmetal"
    ],
    [
      "Matte Black",
      "/collections/colour-matte-black",
      "matte-black"
    ]
  ],
  "drawerCats": {
    "toilets": {
      "t": "Toilets",
      "all": "/collections/toilet-suites",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-toilet-suites.jpg",
      "hub": "/pages/toilet-suites",
      "guideT": "Toilets Hub",
      "groups": [
        {
          "h": "By type",
          "links": [
            {
              "l": "Back-to-Wall Suites",
              "h": "/collections/back-to-wall-toilet-suites",
              "n": 38,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-toilet-suites.png?v=1782979632",
              "cut": 1,
              "bg": "cutout",
              "pv": "BP-T3_1.webp"
            },
            {
              "l": "In-Wall Toilet Packages",
              "h": "/collections/in-wall-toilet-packages",
              "n": 21,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg?v=1755815225",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Faced Pans",
              "h": "/collections/wall-faced-pans",
              "n": 14,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-faced-pans.png?v=1782979730",
              "cut": 1,
              "bg": "cutout",
              "pv": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
            },
            {
              "l": "Wall Hung Pans",
              "h": "/collections/wall-hung-pans",
              "n": 6,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-pans.png?v=1782979731",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Close Coupled Suites",
              "h": "/collections/close-coupled-toilet-suites",
              "n": 5,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-close-coupled-toilet-suites.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Smart Toilets",
              "h": "/collections/smart-toilets",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/KS100_6.jpg?v=1778150707",
              "cut": 0,
              "bg": "photo"
            }
          ]
        },
        {
          "h": "In-wall & parts",
          "links": [
            {
              "l": "Concealed Cisterns",
              "h": "/collections/in-wall-concealed-cisterns",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-concealed-cisterns.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "In Wall Cistern Buttons",
              "h": "/collections/in-wall-cistern-buttons",
              "n": 55,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/DAS_294538_20170926_141550.jpg?v=1755730482",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Back to Wall Toilet Buttons",
              "h": "/collections/back-to-wall-toilet-buttons",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-cistern-buttons.png?v=1782979661",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bidet Sprays",
              "h": "/collections/bidet-sprays",
              "n": 21,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ZAR-BS-DC-CH_01_c8d0941b-9b91-44d5-826c-c4f4df58ae81.jpg?v=1755815418",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Spare Parts",
              "h": "/collections/toilet-spare-parts",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-spare-parts.png?v=1782979721",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bidet Seats",
              "h": "/collections/bidet-seats",
              "n": 5,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Kare-659G-4-Website.jpg?v=1782699201",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "toilets",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "baths": {
      "t": "Baths",
      "all": "/collections/bathtubs",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathtubs.jpg",
      "hub": "/pages/bathtubs",
      "guideT": "Baths Hub",
      "groups": [
        {
          "h": "Shop by Type",
          "links": [
            {
              "l": "Freestanding Baths",
              "h": "/collections/freestanding-baths",
              "n": 143,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-baths.png?v=1782979661",
              "cut": 1,
              "bg": "cutout",
              "pv": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
            },
            {
              "l": "Back to Wall Baths",
              "h": "/collections/back-to-wall-baths",
              "n": 34,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-baths.png?v=1782979632",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Corner Baths",
              "h": "/collections/corner-baths",
              "n": 44,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-corner-baths.png?v=1782979641",
              "cut": 1,
              "bg": "cutout",
              "pv": "vienna-lh-1.jpg"
            },
            {
              "l": "Multi-fit Baths",
              "h": "/collections/multi-fit-baths",
              "n": 13,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-multi-fit-baths.png?v=1782979682",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Stone Baths",
              "h": "/collections/stone-baths",
              "n": 46,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-baths.png?v=1782979711",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath & Shower Tapware Sets",
              "h": "/collections/bath-shower-tapware-sets",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Shop by Material",
          "compact": true,
          "links": [
            {
              "l": "Acrylic",
              "h": "/collections/bathtubs?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F245019639957",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/FR11775GW-OF.jpg?v=1755753504",
              "cut": 0
            },
            {
              "l": "Cast Stone",
              "h": "/collections/bathtubs?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478083221",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ST17.jpg?v=1755730224",
              "cut": 0
            }
          ],
          "visual": "material"
        },
        {
          "h": "Shop by Size",
          "compact": true,
          "links": [
            {
              "l": "1200mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019902101",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "1300mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019934869",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "1400mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245019967637",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "1500mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020000405",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "1600mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020033173",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "1700mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020098709",
              "visual": "size",
              "shape": "bath"
            },
            {
              "l": "Over 1700mm",
              "h": "/collections/bathtubs?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F245020164245",
              "visual": "size",
              "shape": "bath"
            }
          ],
          "visual": "size"
        },
        {
          "h": "Finish the look",
          "links": [
            {
              "l": "Bath Wastes",
              "h": "/collections/bath-wastes",
              "n": 53,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath Spouts",
              "h": "/collections/bath-spouts",
              "n": 180,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ms05-pvdbn-brushed-nickel-wall-spout-meir-1_1024x1024_db6ae806-9d2b-41d3-819d-556fe651d53b.jpg?v=1755583521",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Mixers",
              "h": "/collections/freestanding-bath-mixers",
              "n": 119,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/221112-LF.jpg?v=1756341436",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Spouts",
              "h": "/collections/freestanding-bath-spouts",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/20200224114459_970698-scaled.jpg?v=1792190279",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "baths",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "showers": {
      "t": "Showers",
      "all": "/collections/showers",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-showers.jpg",
      "hub": "/pages/showers",
      "guideT": "Showers Hub",
      "groups": [
        {
          "h": "Complete showers",
          "links": [
            {
              "l": "2-in-1 Multi Function",
              "h": "/collections/shower-column-set",
              "n": 251,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/455110CO.jpg?v=1756343664",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hand Shower on Rail",
              "h": "/collections/shower-on-rail",
              "n": 122,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/444118BN.jpg?v=1756343671",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower on Brackets",
              "h": "/collections/shower-brackets",
              "n": 148,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/433202B.jpg?v=1756343707",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath & Shower Tapware Sets",
              "h": "/collections/bath-shower-tapware-sets",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Heads, arms & parts",
          "links": [
            {
              "l": "Shower Heads",
              "h": "/collections/shower-heads",
              "n": 137,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Shower-Rose-300mm-Polished-Chrome.jpg?v=1756434259",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower Head and Arm Sets",
              "h": "/collections/shower-head-and-arm-sets",
              "n": 135,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_60_411109-C.jpg?v=1792130459",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Ceiling Shower Arms",
              "h": "/collections/ceiling-shower-arms",
              "n": 81,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Ceiling-Shower-Arm-300mm-Matte-Black.jpg?v=1756434286",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Shower Arms",
              "h": "/collections/wall-shower-arms",
              "n": 86,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Round-Wall-Shower-Arm-400mm-Brushed-Nickel.jpg?v=1756434265",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hand Shower Pieces",
              "h": "/collections/hand-shower-piece",
              "n": 84,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/mp01-r-pvdbz_meir_lustre_bronze_round__hand_shower-1_800x_461c6b96-ebb0-4b4a-b455-9d8439610734.webp?v=1756278871",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower Hoses & Brackets",
              "h": "/collections/shower-hoses",
              "n": 6,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/433100.jpg?v=1792187175",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Care & accessibility",
          "links": [
            {
              "l": "Care & Disabled Showers",
              "h": "/collections/disabled-shower-products",
              "n": 20,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/lc401_shower_kit.jpg?v=1792141875",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Screens & mixers",
          "links": [
            {
              "l": "Shower Screens",
              "h": "/collections/shower-screens",
              "n": 49,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
              "cut": 0,
              "bg": "photo"
            },
            {
              "l": "Screen Accessories",
              "h": "/collections/shower-screen-accessories",
              "n": 29,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower / Wall Mixers",
              "h": "/collections/shower-wall-mixers",
              "n": 244,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234101B-2-LF.jpg?v=1756341354",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "showers",
      "finishStrip": [
        [
          "Chrome",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/showers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "50% 45%",
      "range": {
        "t": "Fienza Empire Slim",
        "h": "/collections/fienza-empire",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-showers.jpg",
        "description": "Discover matching shapes and finishes."
      }
    },
    "tapware": {
      "t": "Tapware",
      "all": "/collections/bathroom-tapware",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
      "hub": "/pages/bathroom-tapware",
      "guideT": "Tapware Hub",
      "groups": [
        {
          "h": "Bathroom",
          "links": [
            {
              "l": "Basin Mixers",
              "h": "/collections/basin-mixers",
              "n": 282,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234103-LF.jpg?v=1756341172",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Tall Basin Mixers",
              "h": "/collections/tall-basin-mixers",
              "n": 136,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_1_234107GM.jpg?v=1792129954",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Basin Mixers",
              "h": "/collections/wall-basin-mixers",
              "n": 171,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234104BN-LF.jpg?v=1756341259",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "3 Piece Taps",
              "h": "/collections/3-piece-basin-sets",
              "n": 71,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Harrington-3-Hole-Basin-Set_01.jpg?v=1756344021",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower / Wall Mixers",
              "h": "/collections/shower-wall-mixers",
              "n": 244,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234101B-2-LF.jpg?v=1756341354",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Diverter Mixers",
              "h": "/collections/shower-mixers-diverter",
              "n": 170,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234102CO-4.jpg?v=1756341388",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Mixers",
              "h": "/collections/freestanding-bath-mixers",
              "n": 119,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/221112-LF.jpg?v=1756341436",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Taps",
              "h": "/collections/wall-tap-assemblies",
              "n": 82,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MW08-C-Round-Jumper-Valve-Wall-Top-Assembly-Taps.jpg?v=1755563310",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath Spouts",
              "h": "/collections/bath-spouts",
              "n": 180,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ms05-pvdbn-brushed-nickel-wall-spout-meir-1_1024x1024_db6ae806-9d2b-41d3-819d-556fe651d53b.jpg?v=1755583521",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath & Shower Tapware Sets",
              "h": "/collections/bath-shower-tapware-sets",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221903eBN-1.png?v=1792187126",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Bath Spouts",
              "h": "/collections/freestanding-bath-spouts",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/20200224114459_970698-scaled.jpg?v=1792190279",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hob Mixers",
              "h": "/collections/hob-mixers",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/mw12-c_meir_polished_chrome_deck_mounted_mixer-1.jpg?v=1792190283",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Kitchen & laundry",
          "links": [
            {
              "l": "Kitchen & Laundry Mixers",
              "h": "/collections/kitchen-mixers",
              "n": 421,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105BN-LF.jpg?v=1756341214",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pull Out Kitchen Mixers",
              "h": "/collections/pull-out-kitchen-mixers",
              "n": 209,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234108GM_3.jpg?v=1791449460",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Mixers",
              "h": "/collections/laundry-mixers",
              "n": 129,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105B-LF.jpg?v=1756341210",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Boiling, Chilled & Sparkling",
              "h": "/collections/boiling-chilled-sparkling-taps",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/X51-Intelligent-Dispenser-Matte-Black.jpg?v=1755815831",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Filter Taps",
              "h": "/collections/filter-taps",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LF248047CP-Craft-Filter-Faucet-scaled-1.png?v=1755816478",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pot Fillers",
              "h": "/collections/pot-fillers",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MK21_PVDGM_1.png?v=1791951344",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Kitchen Taps",
              "h": "/collections/outdoor-kitchen-taps",
              "n": 11,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Kitchen-Mixer-Stainless-Steel-316.jpg?v=1755819887",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Kitchen Tap Sets",
              "h": "/collections/kitchen-tap-sets",
              "n": 28,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/kara-kitchen-set_5e9cfdb6ba047.jpg?v=1792190287",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "tapware",
      "finishStrip": [
        [
          "Chrome",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/bathroom-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "72% 55%",
      "range": {
        "t": "Fienza Empire Slim",
        "h": "/collections/fienza-empire",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234110UB-LF_2.jpg",
        "description": "Coordinate tapware, showers and accessories."
      }
    },
    "doors": {
      "t": "Door Hardware",
      "all": "/collections/door-hardware",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-door-hardware.jpg",
      "groups": [
        {
          "h": "Handles",
          "links": [
            {
              "l": "Cabinet Handles",
              "h": "/collections/cabinet-handles",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Handles",
              "h": "/collections/door-handles",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH1-PA-PVDBB-2.jpg?v=1791949998",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Sliding Door Hardware",
              "h": "/collections/sliding-door-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH-E1-PVDGM.jpg?v=1791951202",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Hardware & Fittings",
          "links": [
            {
              "l": "Hinges",
              "h": "/collections/hinges",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MDH-H1-PVDBB-1.jpg?v=1791950063",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Bumper",
              "h": "/collections/door-bumper",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-0670-door-stop.jpg?v=1755740189",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Door Accessories",
              "h": "/collections/door-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML4160-Coat-Hook1.jpg?v=1755740305",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Locks, Latches & Cylinders",
              "h": "/collections/locks-latches-cylinders",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Cambridge-SB-Lever-e1635219826340.jpg?v=1756277191",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "doors",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": {
        "t": "Meir Öppen",
        "h": "/collections/meir-oppen",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Collections-OppenCabinetHandles_1402x_218819fb-89bf-4e31-b671-9546e9f3d931.webp",
        "description": "Coordinated handles for your cabinetry."
      }
    },
    "commercial": {
      "t": "Commercial",
      "all": "/collections/commercial-range",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/abby-mb_1.webp?v=1756427448",
      "groups": [
        {
          "h": "Washroom Essentials",
          "links": [
            {
              "l": "Hand Dryers",
              "h": "/collections/hand-dryers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/abby-mb_1.webp?v=1756427448",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Soap Dispensers",
              "h": "/collections/soap-dispensers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MBSOAPOVIA.jpg?v=1781215904",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Paper Towel Combination Units",
              "h": "/collections/paper-towel-combination-units",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HSD-E6015-Black-1_cdafbea4-95f6-4c3d-b938-182cbb184a4d.png?v=1756278516",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Toilet Roll Dispensers",
              "h": "/collections/toilet-roll-dispensers",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HSD-118-Brushed.jpg?v=1752812445",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Baby Change Stations",
              "h": "/collections/baby-change-stations",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML8100H-Open.jpg?v=1755740366",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Care & Accessibility",
          "links": [
            {
              "l": "Grab Rails & Back Rests",
              "h": "/collections/grab-rails-back-rests",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MLR120LH_VPSET.jpg?v=1792141850",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower Seats & Shower Related",
              "h": "/collections/shower-seats-shower-related",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/202099.jpg?v=1792141878",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Specialised Tapware",
              "h": "/collections/specialised-tapware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NR402BZ-1-1.png?v=1756434093",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Mirrors",
              "h": "/collections/mirrors",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/PEM-6095_5.jpg?v=1756434196",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Security & Anti-Ligature Products",
              "h": "/collections/security-anti-ligature-products",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-773ml-1-1.jpg?v=1755740332",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Disabled Tapware",
              "h": "/collections/disabled-tapware",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Kaya_228103D.jpg?v=1792141830",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Ambulant Bathroom Products",
              "h": "/collections/ambulant-bathroom-products",
              "n": 25,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Fienza-ALIX-Rimless-Ambulant-Back-to-Wall-Toilet-Suite-Slim-Seat-Short-Projection.jpg?v=1792141827",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Accessible Washroom Accessories",
              "h": "/collections/accessible-washroom-accessories",
              "n": 52,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ml-725-ss-paper-towel-dispenser.jpg?v=1792141883",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Hardware & Accessories",
          "links": [
            {
              "l": "Commercial Door Hardware",
              "h": "/collections/commercial-door-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ANMB_300.jpg?v=1755740124",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Antimicrobial Hardware",
              "h": "/collections/antimicrobial-hardware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ANMB_XCELSLIDELOCK.jpg?v=1755740173",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bathroom Series",
              "h": "/collections/bathroom-series",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML6000PSS-Lawson-Single-Toilet-Roll-Holder1.jpg?v=1755740362",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hooks",
              "h": "/collections/hooks",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-4155-equipment-hook.jpg?v=1755740296",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shelves",
              "h": "/collections/shelves",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ML9501.jpg?v=1755740082",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Washroom Accessories",
              "h": "/collections/washroom-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ml-710-r-waste-receptacle.jpg?v=1755740221",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "commercial",
      "imageFit": "contain",
      "imagePosition": "50% 50%",
      "range": null
    },
    "outdoor": {
      "t": "Outdoor",
      "all": "/collections/outdoor",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LifestyleRange_OutdoorCombinationShowerRail_MZ1004N-R-SS316_1_1600x_f70f2f9b-6615-4257-8485-056104f1d66e.webp",
      "groups": [
        {
          "h": "Showers & Tapware",
          "links": [
            {
              "l": "Outdoor Shower",
              "h": "/collections/outdoor-shower",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NR162205C01BZ-1-450x450-1.png?v=1756340598",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Tapware",
              "h": "/collections/outdoor-tapware",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Linkware-Elle-316-Wall-Mixer-Matte-Black.jpg?v=1756278254",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Accessories",
              "h": "/collections/outdoor-accessories",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Robe-Hook-Stainless-Steel.jpg?v=1755819892",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Outdoor Kitchens",
          "links": [
            {
              "l": "Outdoor Kitchen Sinks",
              "h": "/collections/outdoor-kitchen-sinks",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Single-Bowl-440x440-Outdoor-Sink-Stainless-Steel-316.jpg?v=1755819889",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Kitchen Taps",
              "h": "/collections/outdoor-kitchen-taps",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Meir-Outdoor-Kitchen-Mixer-Stainless-Steel-316.jpg?v=1755819887",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Drainage",
          "links": [
            {
              "l": "Pool & Shower Grates",
              "h": "/collections/pool-shower-grates",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/tile-inserts.jpg?v=1755469681",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Outdoor Pool & Shower Wastes",
              "h": "/collections/outdoor-pool-shower-wastes",
              "n": 0,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/lauxes-sti21-midnight-product.jpg?v=1792053545",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "outdoor",
      "finishStrip": [
        [
          "Chrome",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Stainless Steel",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/outdoor?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "basins": {
      "t": "Basins",
      "all": "/collections/basins",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-basins.jpg",
      "hub": "/pages/basins",
      "guideT": "Basins Hub",
      "groups": [
        {
          "h": "Shop by Type",
          "links": [
            {
              "l": "Countertop Basins",
              "h": "/collections/counter-top-basins",
              "n": 254,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-counter-top-basins.png?v=1782979640",
              "cut": 1,
              "bg": "cutout",
              "pv": "hero_basin_ac-800x445-1.jpg"
            },
            {
              "l": "Wall Hung Basins",
              "h": "/collections/wall-hung-basins",
              "n": 37,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-basins.png?v=1782979730",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Undermount Basins",
              "h": "/collections/under-basins",
              "n": 39,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-under-basins.png?v=1782979721",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Semi-inset Basins",
              "h": "/collections/semi-inset-basins",
              "n": 39,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-semi-inset-basins.png?v=1782979691",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Freestanding Basins",
              "h": "/collections/freestanding-basins",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-basins.png?v=1782979651",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Inset Basins",
              "h": "/collections/inset-basins",
              "n": 10,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-inset-basins.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Compact Basins",
              "h": "/collections/compact-basins",
              "n": 6,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-compact-basins.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Cast Stone Basins",
              "h": "/collections/cast-stone-basins",
              "n": 61,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cast-stone-basins.png?v=1782979641",
              "cut": 1,
              "bg": "cutout",
              "pv": "ovia-fluted.webp"
            }
          ]
        },
        {
          "h": "Shop by Material",
          "compact": true,
          "links": [
            {
              "l": "Cast Stone",
              "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478083221",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/CSB01-W-1.jpg?v=1755730221",
              "cut": 0
            },
            {
              "l": "Ceramic",
              "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478050453",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/PA4935-1-800x800.jpg?v=1755562536",
              "cut": 0
            },
            {
              "l": "Natural Stone",
              "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478148757",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/0035MB-5-scaled.jpg?v=1755820345",
              "cut": 0
            },
            {
              "l": "Stainless Steel",
              "h": "/collections/basins?filter.p.m.custom.material=gid%3A%2F%2Fshopify%2FMetaobject%2F244478247061",
              "visual": "material",
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Ovia-Stainless-Steel-Basin.png?v=1756181839",
              "cut": 0
            }
          ],
          "visual": "material"
        },
        {
          "h": "Shop by Size",
          "compact": true,
          "links": [
            {
              "l": "Under 350mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478312597",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "350-400mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478345365",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "400-450mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478378133",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "450-500mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478410901",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "500-600mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478443669",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "600-700mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478476437",
              "visual": "size",
              "shape": "basin"
            },
            {
              "l": "Over 700mm",
              "h": "/collections/basins?filter.p.m.custom.width_band=gid%3A%2F%2Fshopify%2FMetaobject%2F244478509205",
              "visual": "size",
              "shape": "basin"
            }
          ],
          "visual": "size"
        },
        {
          "h": "Wastes & traps",
          "links": [
            {
              "l": "Basin Pop Up Wastes",
              "h": "/collections/pop-up-wastes",
              "n": 64,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/WAS72UB_1.jpg?v=1792184577",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Overflow Rings",
              "h": "/collections/basin-overflow-rings",
              "n": 3,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/OVERFLOWUB.jpg?v=1792183819",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bottle Traps",
              "h": "/collections/bottle-traps",
              "n": 39,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Plumbing Parts",
              "h": "/collections/basin-plumbing-parts",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/2fb2f9df8660903fa6f3655cdb430d2c4f9e772e.jpg?v=1792190979",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Vanity Tops",
          "links": [
            {
              "l": "Vanity Tops",
              "h": "/collections/vanity-tops",
              "n": 17,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/JOL90.jpg?v=1792184579",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Stone Tops",
              "h": "/collections/stone-tops",
              "n": 17,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/CrystalPure_503-SF_Full_92d3c819-2958-4998-829b-418e96ad8f0f.jpg?v=1792184581",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "basins",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "kitchen": {
      "t": "Kitchen",
      "all": "/collections/kitchen",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/2020-03-1615.06.51-1_UNDERMOUNT_1443x_036f11ae-f959-4679-ada8-f761f19a42d3.webp",
      "hub": "/pages/kitchen-laundry-sinks",
      "guideT": "Kitchen & laundry Hub",
      "groups": [
        {
          "h": "Sinks",
          "links": [
            {
              "l": "All Kitchen Sinks",
              "h": "/collections/sinks-laundry-tubs",
              "n": 121,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sinks-laundry-tubs.png?v=1782979711",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Single Bowl Sinks",
              "h": "/collections/single-bowls",
              "n": 80,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-single-bowls.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Double Bowl Sinks",
              "h": "/collections/double-bowls",
              "n": 40,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-double-bowls.png?v=1782979651",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Butler Sinks",
              "h": "/collections/butlers-ceramic-sink",
              "n": 24,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-butlers-ceramic-sink.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Granite Sinks",
              "h": "/collections/granite-sinks",
              "n": 55,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-granite-sinks.png?v=1782979661",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Sink Accessories",
              "h": "/collections/sink-accessories",
              "n": 71,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sink-accessories.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Tapware",
          "links": [
            {
              "l": "Kitchen Mixers",
              "h": "/collections/kitchen-mixers",
              "n": 421,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105BN-LF.jpg?v=1756341214",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pull Out Kitchen Mixers",
              "h": "/collections/pull-out-kitchen-mixers",
              "n": 209,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234108GM_3.jpg?v=1791449460",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Boiling, Chilled & Sparkling",
              "h": "/collections/boiling-chilled-sparkling-taps",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/X51-Intelligent-Dispenser-Matte-Black.jpg?v=1755815831",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Filter Taps",
              "h": "/collections/filter-taps",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LF248047CP-Craft-Filter-Faucet-scaled-1.png?v=1755816478",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pot Fillers",
              "h": "/collections/pot-fillers",
              "n": 32,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MK21_PVDGM_1.png?v=1791951344",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Kitchen Tap Sets",
              "h": "/collections/kitchen-tap-sets",
              "n": 28,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/kara-kitchen-set_5e9cfdb6ba047.jpg?v=1792190287",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Finishing touches",
          "links": [
            {
              "l": "Kitchen Accessories",
              "h": "/collections/kitchen-accessories",
              "n": 46,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-accessories.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "kitchen",
      "finishStrip": [
        [
          "Chrome",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/kitchen-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "50% 70%",
      "range": {
        "t": "Meir Lavello",
        "h": "/collections/meir-lavello",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/2020-03-1615.06.51-1_UNDERMOUNT_1443x_036f11ae-f959-4679-ada8-f761f19a42d3.webp",
        "description": "Discover the kitchen sink collection."
      }
    },
    "laundry": {
      "t": "Laundry",
      "all": "/collections/laundry",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/SinkHero_Butler2-600x333-1.jpg",
      "hub": "/pages/kitchen-laundry-sinks",
      "guideT": "Kitchen & laundry Hub",
      "groups": [
        {
          "h": "The laundry",
          "links": [
            {
              "l": "Laundry & Butler Sinks",
              "h": "/collections/laundry-and-butler-sinks",
              "n": 261,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-and-butler-sinks.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Tubs",
              "h": "/collections/laundry-tubs",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-tubs.png?v=1782979672",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Laundry Mixers",
              "h": "/collections/laundry-mixers",
              "n": 129,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/234105B-LF.jpg?v=1756341210",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall Taps",
              "h": "/collections/wall-tap-assemblies",
              "n": 82,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MW08-C-Round-Jumper-Valve-Wall-Top-Assembly-Taps.jpg?v=1755563310",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Finishing touches",
          "links": [
            {
              "l": "Heated Towel Rails",
              "h": "/collections/heated-rails",
              "n": 131,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Robe Hooks",
              "h": "/collections/robe-hooks",
              "n": 122,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_84_88904GM.jpg?v=1792130800",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "laundry",
      "finishStrip": [
        [
          "Chrome",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/laundry-mixers?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "50% 65%",
      "range": null
    },
    "accessories": {
      "t": "Accessories",
      "all": "/collections/bathroom-accessories",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathroom-accessories.jpg",
      "hub": "/pages/bathroom-accessories",
      "guideT": "Accessories Hub",
      "groups": [
        {
          "h": "Towel rails & holders",
          "links": [
            {
              "l": "Single Towel Rails",
              "h": "/collections/towel-bar-rails",
              "n": 226,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88901600_fb18778d-78d5-4713-abd3-0e9d2d21e58f.jpg?v=1756343824",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Double Towel Rails",
              "h": "/collections/double-towel-rails",
              "n": 202,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88908800BN-1_6b8b3f93-7411-47af-93ec-4a6c3897520c.jpg?v=1756343755",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Hand Towel Holders",
              "h": "/collections/hand-towel-holders",
              "n": 89,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88902CO_464f8ab9-bb47-4ea2-a079-5d6a7343035e.jpg?v=1756343826",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Towel Rings",
              "h": "/collections/towel-rings",
              "n": 48,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/mecca-towel-ring_5e9cd831931a5-scaled.jpg?v=1755749288",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Towel Racks & Ladders",
              "h": "/collections/towel-racks-ladders",
              "n": 23,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/mecca-towel-rack_5e9cb4a1c8104-scaled.jpg?v=1792184021",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Everyday accessories",
          "links": [
            {
              "l": "Toilet Paper Holders",
              "h": "/collections/paper-holders",
              "n": 126,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88903B_826d38cd-f1b2-45cd-98ce-ead24f874158.jpg?v=1756343849",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Robe Hooks",
              "h": "/collections/robe-hooks",
              "n": 122,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_84_88904GM.jpg?v=1792130800",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath Shelves",
              "h": "/collections/bathroom-shelves",
              "n": 47,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88907BN_47199e1f-2dd0-486c-900d-b8b20a2d7c28.jpg?v=1756343724",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Soap Dish Holders",
              "h": "/collections/soap-dish-holders",
              "n": 37,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/88906_840dc129-fc94-47bd-8ca9-5cc074d865e0.jpg?v=1756343709",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Soap Dispensers",
              "h": "/collections/soap-dispenser",
              "n": 15,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MP09-Round-Matte-Black-Soap-Dispenser_1024x1024_7510d66b-90e7-4121-bd72-8ebc7170218b.jpg?v=1755583472",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Toilet Brush Holders",
              "h": "/collections/toilet-brush-holder",
              "n": 22,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/889010B_ebc45f4b-3dc9-4288-a40c-abdb6c44b196.jpg?v=1756343711",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bathroom Storage Cabinets",
              "h": "/collections/bathroom-storage-cabinets",
              "n": 2,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/IN3030_product.png?v=1792190293",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Warm & practical",
          "links": [
            {
              "l": "Heated Towel Rails",
              "h": "/collections/heated-rails",
              "n": 131,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Heated Towel Rail Accessories",
              "h": "/collections/heated-towel-rail-accessories",
              "n": 6,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Jeeves_Elements_JE60_JE120_JE135_JE150_JE220.jpg?v=1792190290",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "accessories",
      "finishStrip": [
        [
          "Chrome",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Stainless Steel",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130468020373",
          "stainless-steel"
        ],
        [
          "Matte White",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Black",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F134303907989",
          "black"
        ],
        [
          "Satin/Matte White",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F213295661205",
          "satin-matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ],
        [
          "Gold",
          "/collections/bathroom-accessories?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671810709",
          "gold"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": {
        "t": "Fienza Empire Slim",
        "h": "/collections/fienza-empire",
        "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-bathroom-accessories.jpg",
        "description": "Find the finishing touches for your bathroom."
      }
    },
    "vanities": {
      "t": "Vanities",
      "all": "/collections/bathroom-vanities",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/150RWC_2-1.jpg",
      "hub": "/pages/vanities",
      "guideT": "Vanities Hub",
      "groups": [
        {
          "h": "By type",
          "links": [
            {
              "l": "Wall Hung Vanities",
              "h": "/collections/wall-hung-vanities",
              "n": 159,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-vanities.png?v=1782979731",
              "cut": 1,
              "bg": "cutout",
              "pv": "HE-90W-TO.webp"
            },
            {
              "l": "Vanities on Legs",
              "h": "/collections/vanities-on-legs",
              "n": 22,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-legs.png?v=1782979731",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Vanities on Kickboard",
              "h": "/collections/vanities-on-kickboard",
              "n": 35,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-kickboard.png?v=1782979721",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Small Space Vanities",
              "h": "/collections/small-spaces-vanities",
              "n": 36,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-small-spaces-vanities.png?v=1782979711",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Extras",
          "links": [
            {
              "l": "Stone Tops",
              "h": "/collections/stone-tops",
              "n": 17,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/CrystalPure_503-SF_Full_92d3c819-2958-4998-829b-418e96ad8f0f.jpg?v=1792184581",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Vanity Tops",
              "h": "/collections/vanity-tops-bathroom-vanities",
              "n": 17,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/JOL90_a21cb632-72bf-4b86-b7f5-3637c43f8b58.jpg?v=1792184580",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Cabinet Handles",
              "h": "/collections/cabinet-handles",
              "n": 140,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Vanity Builder",
              "h": "/collections/vanity-builder",
              "n": 18,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-builder.png?v=1782979731",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "vanities",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "mirrors": {
      "t": "Mirrors & Cabinets",
      "all": "/collections/mirror-shaving-cabinets",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/hero_kaya_led_mirror.jpg",
      "hub": "/pages/mirrors-shaving-cabinets",
      "guideT": "Mirrors & Cabinets Hub",
      "groups": [
        {
          "h": "Mirrors",
          "links": [
            {
              "l": "Plain LED Mirrors",
              "h": "/collections/led-mirrors",
              "n": 30,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/600-ROUND_0ffcd049-5a2b-462e-9c0a-604084310e10.webp?v=1792184582",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Framed LED Mirrors",
              "h": "/collections/framed-led-mirrors",
              "n": 57,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/led700frub_a4937ee4-aa92-4502-8c95-2dab8377f680.jpg?v=1792183829",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Smart Mirrors",
              "h": "/collections/smart-mirrors",
              "n": 2,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/Delta-800-1.jpg?v=1782699133",
              "cut": 0
            },
            {
              "l": "Round Mirrors",
              "h": "/collections/rounds",
              "n": 13,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-rounds.png?v=1782979691",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Pencil Edge Mirrors",
              "h": "/collections/pencil-edge-mirrors",
              "n": 23,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pencil-edge-mirrors.png?v=1782979681",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Framed Coloured Mirrors",
              "h": "/collections/framed-coloured-mirrors",
              "n": 52,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-framed-coloured-mirrors.png?v=1782979651",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Cabinets",
          "links": [
            {
              "l": "Shaving Cabinets",
              "h": "/collections/shaving-cabinets",
              "n": 111,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shaving-cabinets.png?v=1782979691",
              "cut": 1,
              "bg": "cutout",
              "pv": "PSC1200SX-fienza-lifestyle.webp"
            },
            {
              "l": "LED Shaving Cabinets",
              "h": "/collections/led-shaving-cabinets",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-shaving-cabinets.png?v=1782979682",
              "cut": 1,
              "bg": "cutout",
              "pv": "AT-5090A-MW1.webp"
            }
          ]
        }
      ],
      "brandKey": "mirrors",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "wastes": {
      "t": "Wastes & Traps",
      "all": "/collections/wastes-and-traps",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/floorwaste-lifestyle.jpg",
      "hub": "/pages/shower-wastes",
      "guideT": "Wastes & Traps Hub",
      "groups": [
        {
          "h": "By type",
          "links": [
            {
              "l": "Floor Wastes",
              "h": "/collections/floor-wastes",
              "n": 41,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wastes.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Tile Insert Floor Wastes",
              "h": "/collections/tile-insert-floor-wastes",
              "n": 56,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-floor-wastes.png?v=1782979651",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wedge Wire Channels",
              "h": "/collections/wedge-wire-channels",
              "n": 20,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/wedge-wire-grates.jpg?v=1755469687",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Tile Insert Channels",
              "h": "/collections/tile-insert-channels",
              "n": 30,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/lauxes-sti21-midnight-product.jpg?v=1792053545",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bath Wastes",
              "h": "/collections/bath-wastes",
              "n": 53,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Pop Up Wastes",
              "h": "/collections/pop-up-wastes",
              "n": 64,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/WAS72UB_1.jpg?v=1792184577",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Overflow Rings",
              "h": "/collections/basin-overflow-rings",
              "n": 3,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/OVERFLOWUB.jpg?v=1792183819",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Bottle Traps",
              "h": "/collections/bottle-traps",
              "n": 39,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Plumbing Parts",
              "h": "/collections/basin-plumbing-parts",
              "n": 8,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/2fb2f9df8660903fa6f3655cdb430d2c4f9e772e.jpg?v=1792190979",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "wastes",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "heating": {
      "t": "Heating & Cooling",
      "all": "/collections/heating-and-cooling",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/HEATED-TOWEL-LADDER-GR-lifestyle-image-1.jpg",
      "hub": "/pages/heating-cooling",
      "guideT": "Heating & Cooling Hub",
      "groups": [
        {
          "h": "Keep it warm",
          "links": [
            {
              "l": "Heated Towel Rails",
              "h": "/collections/heated-rails",
              "n": 131,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/BSD_Fienza_88_889900_1.jpg?v=1792130825",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Underfloor Heating",
              "h": "/collections/underfloor-heating",
              "n": 62,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-underfloor-heating.png?v=1782979721",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Heating Timers & Thermostats",
              "h": "/collections/heating-thermostats",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-thermostats.png?v=1782979661",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "All Heating & Cooling",
              "h": "/collections/heating-and-cooling",
              "n": 155,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Heated Towel Rail Accessories",
              "h": "/collections/heated-towel-rail-accessories",
              "n": 6,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Jeeves_Elements_JE60_JE120_JE135_JE150_JE220.jpg?v=1792190290",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "heating",
      "finishStrip": [
        [
          "Chrome",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467889301",
          "chrome"
        ],
        [
          "Matte Black",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467823765",
          "matte-black"
        ],
        [
          "Brushed Nickel",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
          "brushed-nickel"
        ],
        [
          "Warm Brushed Nickel",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
          "warm-brushed-nickel"
        ],
        [
          "Gunmetal",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467758229",
          "gunmetal"
        ],
        [
          "Brushed Gold",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467627157",
          "brushed-gold"
        ],
        [
          "Champagne",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467856533",
          "champagne"
        ],
        [
          "Antique Brass",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F164442407061",
          "antique-brass"
        ],
        [
          "Matte White",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467790997",
          "matte-white"
        ],
        [
          "Brushed Bronze / Copper",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467922069",
          "brushed-bronze"
        ],
        [
          "Dusk",
          "/collections/heated-rails?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F614671843477",
          "dusk"
        ]
      ],
      "strip": "fin",
      "imageFit": "cover",
      "imagePosition": "65% 50%",
      "range": null
    },
    "care": {
      "t": "Care & Ambulant",
      "all": "/collections/disabled-care-products",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-cat-special-disabled.jpg",
      "hub": "/pages/disabled-care",
      "guideT": "Care & Ambulant Hub",
      "groups": [
        {
          "h": "Care toilets & support",
          "links": [
            {
              "l": "Care & Extra-Height Toilets",
              "h": "/collections/care-toilets",
              "n": 10,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ZurichBTW2.png?v=1792141836",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Care Toilet Suites",
              "h": "/collections/disabled-toilet-suites",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Fienza-Disabled-Delta-Care-Back-to-Wall-Suite-Blue-Seat-S-Trap_01.jpg?v=1792141839",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Ambulant Toilets",
              "h": "/collections/ambulant-toilets",
              "n": 2,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Vera-MB-020_703b99df-9711-42fc-8348-74d6b2fb7aa5.png?v=1792141841",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Ambulant Grab Rails",
              "h": "/collections/ambulant-grab-rails",
              "n": 21,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/FC4141.jpg?v=1792141844",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Grab Rails & Backrests",
              "h": "/collections/grab-rails-back-rests",
              "n": 156,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MLR120LH_VPSET.jpg?v=1792141850",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Care Toilet Accessories",
              "h": "/collections/care-toilet-accessories",
              "n": 18,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/200990_3.jpg?v=1792141853",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Disabled tapware",
          "links": [
            {
              "l": "All Disabled Tapware",
              "h": "/collections/disabled-tapware",
              "n": 43,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/Kaya_228103D.jpg?v=1792141830",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Basin Taps & Mixers",
              "h": "/collections/disability-basin-mixers",
              "n": 23,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/213109D.jpg?v=1792141856",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Wall & Shower Mixers",
              "h": "/collections/disability-shower-wall-mixers",
              "n": 10,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/NR221909XCH.png?v=1792141859",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Kitchen & Sink Mixers",
              "h": "/collections/disability-kitchen-mixers",
              "n": 3,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/213110D.jpg?v=1792141862",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Extended Mixer Handles",
              "h": "/collections/extended-mixer-handles",
              "n": 7,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/classic-care-handle-only_5e9cf7d0cb28b-scaled.jpg?v=1792141865",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        },
        {
          "h": "Basins, showers & accessories",
          "links": [
            {
              "l": "Care Basins",
              "h": "/collections/disability-basins",
              "n": 5,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/RB379S_88204e88-c779-4540-ba06-39823ea52c9e.jpg?v=1792141868",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Care Mirrors",
              "h": "/collections/disabled-mirror",
              "n": 5,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/PEM-4595_5_d9e15366-4b4c-420f-85b3-40111456d668.jpg?v=1792141872",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Care Showers",
              "h": "/collections/disabled-shower-products",
              "n": 20,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/lc401_shower_kit.jpg?v=1792141875",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Shower Seats",
              "h": "/collections/shower-seats-shower-related",
              "n": 9,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/202099.jpg?v=1792141878",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Care Bathroom Accessories",
              "h": "/collections/care-bathroom-accessories",
              "n": 24,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/MCR-TPH-PVDBB.webp?v=1792141880",
              "cut": 1,
              "bg": "cutout"
            },
            {
              "l": "Accessible Washroom Accessories",
              "h": "/collections/accessible-washroom-accessories",
              "n": 52,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/collections/ml-725-ss-paper-towel-dispenser.jpg?v=1792141883",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "care",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    },
    "screens": {
      "t": "Shower Screens",
      "all": "/collections/shower-screens",
      "coll": "/collections/shower-screens",
      "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
      "groups": [
        {
          "h": "Screens & fittings",
          "links": [
            {
              "l": "Shower Screens",
              "h": "/collections/shower-screens",
              "n": 49,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/10C-90-MB.jpg?v=1780968434",
              "cut": 0,
              "bg": "photo"
            },
            {
              "l": "Screen Accessories",
              "h": "/collections/shower-screen-accessories",
              "n": 29,
              "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
              "cut": 1,
              "bg": "cutout"
            }
          ]
        }
      ],
      "brandKey": "showers",
      "imageFit": "cover",
      "imagePosition": "50% 50%",
      "range": null
    }
  },
  "mdExtra": [],
  "xdExtra": {}
};


(function () {
  'use strict';
  var element = document.getElementById('atNavCollectionCounts');
  var counts = {};
  try { counts = element ? JSON.parse(element.textContent) : {}; } catch (error) {}
  function applyCounts(value) {
    if (!value || typeof value !== 'object') return;
    if (!Array.isArray(value) && Object.prototype.hasOwnProperty.call(value, 'n')) {
      var url = value.coll || value.h;
      if (typeof url === 'string' && url.indexOf('/collections/') === 0) {
        var count = counts[url];
        value.n = typeof count === 'number' && count >= 0 ? count : 0;
      }
    }
    Object.keys(value).forEach(function (key) { applyCounts(value[key]); });
  }
  applyCounts(window.NAV2);
  ["doors", "commercial", "outdoor"].forEach(function (key) {
    [window.NAV2.mega[key], window.NAV2.drawerCats[key]].forEach(function (department) {
      department.groups = department.groups.map(function (group) {
        group.links = group.links.filter(function (link) { return link.visual || link.n > 0; });
        return group;
      }).filter(function (group) { return group.links.length > 0; });
    });
  });
}());






